import React from 'react';

interface Props {
  color?: string;
  size?: number;
}

/**
 * 人物アイコン（フッターナビ「マイページ」）
 * 元SVG offset (-265, -1135) を M 座標に適用済み
 * viewBox: 0 0 28 26
 */
const PersonNavIcon: React.FC<Props> = ({ color = 'currentColor', size = 40 }) => (
  <svg
    viewBox="0 0 28 26"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill={color}
      d="M23.69,20.91c.17-.27.33-.55.47-.83.05-.1.09-.19.14-.29.12-.25.23-.51.33-.77.05-.12.09-.24.13-.36.09-.25.16-.51.23-.76.03-.13.07-.26.1-.39.06-.27.11-.55.15-.82.02-.12.04-.24.06-.36.04-.4.07-.81.07-1.22,0-6.08-4.92-11-11-11s-11,4.92-11,11c0,.41.03.82.07,1.22.01.12.04.24.06.36.04.28.08.55.15.82.03.13.07.26.1.39.07.26.14.51.23.76.04.12.09.24.13.36.1.26.21.52.33.77.05.1.09.19.14.29.15.29.3.56.47.83.03.05.06.11.1.16,1.96,3.02,5.36,5.03,9.23,5.03s7.27-2.01,9.23-5.03c.03-.05.06-.11.1-.16ZM20.74,21.45c-.34-.9-.86-1.72-1.53-2.39-.84-.84-1.9-1.46-3.07-1.77.44-.2.84-.49,1.17-.84.75-.73,1.22-1.77,1.22-2.92s-.46-2.19-1.22-2.94-1.79-1.22-2.94-1.22-2.17.46-2.92,1.22-1.22,1.79-1.22,2.94.46,2.19,1.22,2.92c.33.35.73.64,1.17.84-1.17.31-2.23.93-3.07,1.77-.67.67-1.2,1.49-1.55,2.39ZM8,21.46h0c-.81-.81-1.47-1.78-1.93-2.86,0-.02-.01-.04-.02-.06-.1-.25-.2-.5-.28-.76-.01-.04-.02-.09-.03-.13-.07-.24-.14-.48-.19-.73-.02-.12-.03-.23-.05-.35-.03-.18-.06-.36-.08-.54-.03-.3-.05-.61-.05-.92,0-4.96,4.04-9,9-9s9,4.04,9,9c0,.31-.02.62-.05.92-.02.16-.05.31-.07.47-.02.14-.04.28-.06.42-.05.24-.11.47-.18.71-.01.05-.02.1-.04.15-.08.26-.18.52-.28.77,0,.02-.01.03-.02.05-.45,1.07-1.11,2.04-1.92,2.86h0Z"
    />
  </svg>
);

export default PersonNavIcon;
